export default __webpack_public_path__ + "static/media/attendance_plan.ed5ed07f.svg";